/**
 * Single isolation point for JWT access/refresh tokens.
 *
 * Nothing outside this module should read or write tokens directly. The access
 * token is held in memory (not persisted) to limit XSS exposure; the refresh
 * token is persisted so a page reload can re-establish the session.
 *
 * Preferred long-term: have the backend issue httpOnly cookies and drop
 * client-side token storage entirely — the axios client already sends
 * credentials, so only this module would change.
 */

const REFRESH_KEY = 'osvitly.refresh';

let accessToken: string | null = null;

export const tokenStorage = {
  getAccess(): string | null {
    return accessToken;
  },

  getRefresh(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY);
    } catch {
      return null;
    }
  },

  set(access: string, refresh?: string): void {
    accessToken = access;
    if (refresh !== undefined) {
      try {
        localStorage.setItem(REFRESH_KEY, refresh);
      } catch {
        /* storage unavailable (private mode) — access token still works in-memory */
      }
    }
  },

  clear(): void {
    accessToken = null;
    try {
      localStorage.removeItem(REFRESH_KEY);
    } catch {
      /* ignore */
    }
  },
};
